import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyDKNe9IMBA2BLKnXo58_SQG8vVTI_scdEw',
  authDomain: 'calisfix-4301d.firebaseapp.com',
  // Confirmed from the project's GoogleService-Info.plist DATABASE_URL after
  // enabling Realtime Database (default us-central1 instance).
  databaseURL: 'https://calisfix-4301d-default-rtdb.firebaseio.com',
  projectId: 'calisfix-4301d',
  storageBucket: 'calisfix-4301d.firebasestorage.app',
  messagingSenderId: '137021308894',
  appId: '1:137021308894:web:4b10a854a98a4507f4e74f',
  measurementId: 'G-PCR3X2SH6Z'
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const database = getDatabase(firebaseApp);

export { firebaseApp, messaging, database };
